module.exports = __webpack_public_path__ + "img/ld_4@2x.739c0f5f.png";